const XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;

module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-mini/src/lib/XMLHttpRequest.js
// module id = 2428
// module chunks = 0 1